import DatePicker from "vue-datepicker-next";
import langPl from "vue-datepicker-next/locale/pl.es";
import langEs from "vue-datepicker-next/locale/es.es";
import langPtBr from "vue-datepicker-next/locale/pt-br.es";

export default {
  install() {
    const localLang = window.EDRONE_CONTEXT?.user.lang || "en";
    try {
      switch (localLang) {
        case "pl":
          DatePicker.locale("pl", langPl);
          break;
        case "es":
          DatePicker.locale("es", langEs);
          break;
        case "pt":
          DatePicker.locale("pt-br", langPtBr);
          break;
        case "en":
        default:
          DatePicker.locale("en");
          break;
      }
    } catch (error) {
      console.warn("DatePicker.locale() failed, using default", error);
    }
  },
};
